import { render, staticRenderFns } from "./Confetti.vue?vue&type=template&id=094d663d"
import script from "./Confetti.vue?vue&type=script&lang=js"
export * from "./Confetti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports